import { it } from 'date-fns/locale/it';
import { useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { colors } from '../../ui/colors';
import { ArrowLeftIcon } from "../../ui/icons/arrow-left";
import { Layout } from "../../ui/layout";
import { ButtonComponent } from '../../ui/molecules/button/newButton';
import InputMultiSearch from '../../ui/molecules/input/InputMultiSearch';
import RadioButtonGroup from "../../ui/molecules/RadioButtonGroup";
import { MadfarmStaticSelect } from '../../ui/molecules/select/newSelect/static';
import { ClientTypology } from "../../ui/organisms/clientTypology";
import { CustomHorizontalTab } from "../../ui/organisms/customHorizontalTab";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { RightBar } from "../../ui/organisms/rightBar";
import { AuthorityOffices } from "../../ui/organisms/sedeDiCompetenza";
import { normativa } from "../../utils";
import { Bio } from "../normative/bio";
import { GlobalGap } from "../normative/global";
import { ProduzioneIntegrata } from "../normative/prodInteg";
import { ResiduoZero } from "../normative/residuoZero";
import { QualitaSicura } from "../normative/safeQuality";
import { BoxAnagrafica } from "./boxAnagrafica";
import { BoxCentriAziendali } from "./boxCentriAziendali";
import { BoxRappLegale } from "./boxRappLegale";
import { BoxRubrica } from "./boxRubrica";
import { BoxTecnicoAziendale } from "./boxTecnicoAziendale";
import { GgAddModules } from './feature/addOn/dto';
import { createAddOn } from './feature/addOn/slice';
import { CodeType, CustomerByCodeResponseDTO } from './feature/dto';
import { createCustomer, getCustomerByCode, getCustomerById, setCustomerCreateRequestField, setSelectedCustomerTab, validateCustomerCreateRequest } from './feature/slice';

registerLocale('it', it)

export function NewCliente() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const [normSelected, setNormSelected] = useState('')
    const [selectedOption, setSelectedOption] = useState<CodeType | null>(null)
    const [codeDisabled, setCodeDisabled] = useState(true)

    const customerState = useAppSelector(state => state.customer)

    const handleOptionChange = (value: CodeType) => {
        setSelectedOption(value)
        if (value === CodeType.CODICE_ESISTENTE) {
            setCodeDisabled(false)
            dispatch(setCustomerCreateRequestField({ field: 'codeType', value: CodeType.CODICE_ESISTENTE }))
        } else {
            setCodeDisabled(true)
            dispatch(setCustomerCreateRequestField({ field: 'codeType', value: CodeType.NUOVO_CODICE }))
        }
    }

    // useEffect(() => {
    //     dispatch(setOnEditCustomer(false));
    // }, [])

    // useEffect(() => {
    //     if (clientiState.validateNewCustomerStatus === 'successfully') {
    //         dispatch(setValidateNewCustomerStatus('idle'))
    //     } else if (clientiState.validateNewCustomerStatus === 'failed') {
    //         setShowError(true)
    //     }
    // }, [clientiState.validateNewCustomerStatus])

    // useEffect(() => {
    //     if (clientiState.validateNewLegalRappStatus === 'successfully') {
    //         dispatch(CustomerCreation(clientiState.clienteEditCreateRequest))
    //         dispatch(setValidateNewLegalRappStatus('idle'))
    //     } else if (clientiState.validateNewLegalRappStatus === 'failed') {
    //         setShowError(true)
    //     }
    // }, [clientiState.validateNewLegalRappStatus])

    // useEffect(() => {
    //     if (clientiState.customerCreateResponseStatus === 'successfully' && clientiState.customerId) {
    //         dispatch(GetCustomersById(clientiState.customerId))
    //         dispatch(resetCustomerByIdStatus('idle'))
    //     }
    // }, [clientiState.customerCreateResponseStatus, clientiState.customerId])

    // useEffect(() => {
    //     if (clientiState.getCustomersByIdResponseStatus === 'successfully') {
    //         dispatch(setCustomerId(clientiState.getCustomersByIdResponse?.id))
    //         dispatch(RappLegaleCreation(clientiState.rappLegaleEditCreateRequest))
    //         dispatch(ContactsCreation(clientiState.contactsCreateRequest))
    //         setTimeout(() => {
    //             clientiState.corporateCenters.map(value => dispatch(CenterCompanyCreation(value)))
    //         }, 1000)
    //         resetCreateStatus('idle')
    //         setShowSuccess(true)
    //     }
    // }, [clientiState.getCustomersByIdResponseStatus])

    // useEffect(() => {
    //     if (clientiState.customerId) {
    //         dispatch(setCustomerBusinessTech(clientiState.customerId.toString()))
    //     }
    // }, [clientiState.customerId])

    // useEffect(() => {
    //     if (businessTechinianState.userBusinessTechnicianLink.id) {
    //         dispatch(linkBusinessTech(businessTechinianState.userBusinessTechnicianLink))
    //     }
    // }, [businessTechinianState.userBusinessTechnicianLink.id])

    // useEffect(() => {
    //     if (clientiState.customerCreateResponseStatus === 'successfully') {
    //         setShowSuccessRl(true)
    //         resetCreateRappLegaleStatus('idle')
    //     }
    // }, [clientiState.rappLegaleCreateResponseStatus])

    // useEffect(() => {
    //     if (clientiState.corporateCenterCreateResponseStatus === 'successfully') {
    //         setShowSuccessCa(true)
    //         resetCreateCompanyCenterStatus('idle')
    //     }
    // }, [clientiState.corporateCenterCreateResponseStatus])

    // useEffect(() => {
    //     if (clientiState.contactsCreateResponseStatus === 'successfully') {
    //         setShowSuccessContacts(true)
    //         resetContactsStatus('idle')
    //     }
    // }, [clientiState.contactsCreateResponseStatus])

    // useEffect(() => {
    //     if (showSuccess && showSuccessRl && showSuccessContacts) {
    //         const t = setTimeout(() => {
    //             setShowSuccess(false)
    //             setShowSuccessContacts(false)
    //             setShowSuccessRl(false)
    //         }, 2500)
    //         return () => clearTimeout(t)
    //     }
    // }, [showSuccess, showSuccessContacts, showSuccessRl])

    return (
        <Layout
            menuItem={MenuItems.CLIENTI}
            breadcrumbItems={['Clienti', 'Nuovo Cliente']}
            headerLabel="Nuovo Cliente"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/customers')} color={colors.brandPrimary[50]} size={0} />
            }
            rightBar
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Salva cliente'
                        onClick={() => {
                            dispatch(validateCustomerCreateRequest(customerState.customerCreateRequest))
                                .unwrap()
                                .then(() =>
                                    dispatch(createCustomer(customerState.customerCreateRequest)).unwrap()
                                )
                                .then((createdCustomerId: number) => {
                                    const addOns = customerState.customerCreateRequest.ggAddOns ?? [];
                                    return Promise.all(
                                        addOns.map(addOn =>
                                            dispatch(createAddOn({
                                                starting: addOn.starting ?? null,
                                                ending: addOn.ending ?? null,
                                                addOn: addOn.addOn || '',
                                                addModule: addOn.addModule as GgAddModules,
                                                customerDataId: String(createdCustomerId),
                                                active: true,
                                            })).unwrap()
                                        )
                                    ).then(() => createdCustomerId);
                                })
                                .then((createdCustomerId: number) => {
                                    dispatch(getCustomerById(String(createdCustomerId)));
                                    navigate('/edit-customer/' + createdCustomerId)
                                })
                                .catch(() => { });
                        }}
                    />
                </div>
            }
        >
            <div className="flex flex-col w-full h-full overflow-hidden">
                <div className="bg-white shrink-0">
                    <CustomHorizontalTab
                        selectedIndex={customerState.selectedCustomerTab}
                        onTabClick={(index) => dispatch(setSelectedCustomerTab(index))}
                    >
                        <div>
                            Anagrafica
                        </div>
                        <div data-disabled={true}>Centri Aziendali</div>
                        <div
                            data-disabled={true}
                        >
                            Rappresentante Legale
                        </div>
                        <div data-disabled={true}>Tecnico Aziendale</div>
                        <div data-disabled={true}>Rubrica</div>
                    </CustomHorizontalTab>
                    {/* {(showError || ((showSuccess && showSuccessRl) || showSuccessContacts)) && (
                        <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                            <SuccessPopup
                                active={(showSuccess && showSuccessRl) || showSuccessContacts}
                                message="Dati salvati correttamente."
                                onClose={() => {
                                    setShowSuccess(false)
                                    setShowSuccessContacts(false)
                                    setShowSuccessRl(false)
                                }}
                            />
                            <ErrorPopup
                                active={showError}
                                message="Si è verificato un errore durante la creazione del cliente."
                                onClose={() => {
                                    setShowError(false)
                                    dispatch(resetCreateStatus('idle'))
                                }}
                            />
                        </div>
                    )} */}
                </div>
                <div className="flex flex-1 overflow-hidden">
                    <div className="flex-[0.7] overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200">
                        {customerState.selectedCustomerTab === 0 && <BoxAnagrafica />}
                        {customerState.selectedCustomerTab === 1 && <BoxCentriAziendali />}
                        {customerState.selectedCustomerTab === 2 && <BoxRappLegale />}
                        {customerState.selectedCustomerTab === 3 && <BoxTecnicoAziendale />}
                        {customerState.selectedCustomerTab === 4 && <BoxRubrica />}
                    </div>
                    <div className="flex-[0.3] overflow-y-auto bg-white">
                        <RightBar>
                            <div className="flex flex-col gap-5 w-full">
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Norma di riferimento<span className="text-red-500"> *</span></span>
                                    <MadfarmStaticSelect
                                        error={!!customerState.customerCreateErrors.norm}
                                        errorLabel={customerState.customerCreateErrors.norm}
                                        isClearable
                                        placeholder="Norma"
                                        options={normativa}
                                        value={normSelected}
                                        onChange={(value) => {
                                            // @ts-ignore
                                            const newValue = value !== null ? value.value : null
                                            dispatch(setCustomerCreateRequestField({ field: 'norm', value: newValue }))
                                            setNormSelected(newValue)
                                        }}
                                        noOptionsMessage="Nessuna norma trovata"
                                    />
                                    {normSelected === 'NORMA_BIO' ? <Bio mode="create" />
                                        : normSelected === 'PRODUZIONE_INTEGRATA' ? <ProduzioneIntegrata mode="create" />
                                            : normSelected === 'QUALITA_SICURA' ? <QualitaSicura mode="create" />
                                                : normSelected === 'RESIDUO_ZERO' ? <ResiduoZero mode="create" />
                                                    : normSelected === 'GLOBAL_GAP' ? <GlobalGap mode="create" />
                                                        : null}
                                </div>
                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Codice cliente</span>
                                    <RadioButtonGroup
                                        name="code_type"
                                        options={Object.values(CodeType)}
                                        selectedValue={selectedOption}
                                        onChange={handleOptionChange}
                                        optionLabels={{
                                            [CodeType.NUOVO_CODICE]: 'Nuovo Codice',
                                            [CodeType.CODICE_ESISTENTE]: 'Codice Esistente',
                                        }}
                                    />
                                    <InputMultiSearch
                                        searchOne
                                        disabled={codeDisabled}
                                        placeholder="Cerca codice"
                                        getId={(item: CustomerByCodeResponseDTO) => item.clientCode}
                                        onSearch={(q) =>
                                            dispatch(getCustomerByCode(q))
                                                .unwrap()
                                                .then((res) => res?.data ?? [])
                                        }
                                        onSelect={(clientCode) => dispatch(setCustomerCreateRequestField({ field: 'existingCode', value: clientCode }))}
                                    />
                                </div>

                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Tipologia cliente<span className="text-red-500"> *</span></span>
                                    <ClientTypology mode="create" />
                                </div>
                                <div className="border-t border-neutral-200" />
                                <div className="flex flex-col gap-3">
                                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Sede di competenza<span className="text-red-500"> *</span></span>
                                    <AuthorityOffices mode="create" />
                                </div>

                            </div>
                        </RightBar>
                    </div>
                </div>
            </div>
        </Layout>
    )
}